import { useQuery } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { projectBySlugQueryOptions } from '@/entities/project'
import { useSession } from '@/entities/session'
import { Breadcrumb, type Crumb } from '@/shared/ui/breadcrumb'
import { MEETING_TABS, MeetingPageView } from '../-ui/meeting-page'

const MeetingSearchSchema = z.object({
  tab: z.enum(MEETING_TABS).optional().catch(undefined),
})

export const Route = createFileRoute('/_app/$company/$project_/meetings/$meeting')({
  validateSearch: (search) => MeetingSearchSchema.parse(search),
  head: () => ({ meta: [{ title: 'Встреча · STIT Deal' }] }),
  component: ProjectMeetingPage,
})

function ProjectMeetingPage() {
  const { company, project, meeting: meetingId } = Route.useParams()
  const { tab } = Route.useSearch()
  const navigate = Route.useNavigate()
  const { session } = useSession()
  const isEmployee = session?.kind === 'employee'

  const projectQ = useQuery(projectBySlugQueryOptions(company, project))
  const d = projectQ.data

  return (
    <MeetingPageView
      meetingId={meetingId}
      activeTab={tab ?? 'comments'}
      onTabChange={(value) => void navigate({ search: { tab: value } })}
      docLink={(docId) => ({
        to: '/$company/$project/documents/$doc',
        params: { company, project, doc: docId },
      })}
      onDeleted={() =>
        void navigate({
          to: '/$company/$project',
          params: { company, project },
          search: { tab: 'meetings' },
        })
      }
      renderBreadcrumb={(m) => (
        <Breadcrumb
          items={
            [
              isEmployee
                ? {
                    label: d?.company_name ?? company,
                    to: '/companies/$company',
                    params: { company },
                  }
                : { label: d?.company_name ?? company },
              {
                label: d?.title ?? project,
                to: '/$company/$project',
                params: { company, project },
              },
              {
                label: 'Встречи',
                to: '/$company/$project',
                params: { company, project },
                search: { tab: 'meetings' },
              },
              { label: m.title },
            ] satisfies Crumb[]
          }
        />
      )}
    />
  )
}
